import { KeywordActionTypes } from "../types";
import {
  IWorkflowItemStep,
  IKeywords,
  IReport
} from "../../../../common/sharedTypes";
import Api from "../../../../services/Api";
import { ApiResponse } from "apisauce";
import { toast } from "react-toastify";
import {
  CountyInfo,
  ReportTypesInfo,
  ISearchKeywordQueuePagedResponse,
  SearchKeywordQueuePagedRequest,
  KeywordQueueItem
} from "../business-objects/common";
import { IPaperKeywordRequest } from "./../business-objects/common";
import { b64toBlob } from "../../../PrintPDF/common/utils";
import * as documentDownloadService from "../../../../services/documentDownloadService";
import * as urls from "../../../shared/urls";

export const searchKeywords = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        //this.setState({ data: response.data });
        dispatch(setKeywords(response.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const getKeywordQueueItems = async (
  url: string,
  request: SearchKeywordQueuePagedRequest
): Promise<ApiResponse<ISearchKeywordQueuePagedResponse>> => {
  return await Api.post(url, request);
};

export const searchKeywordsPaged = (
  url: string,
  request: SearchKeywordQueuePagedRequest
) => {
  return async (dispatch) => {
    dispatch(setLoadingQueueItems(true));
    try {
      const response = await getKeywordQueueItems(url, request);
      const searchResponse: ISearchKeywordQueuePagedResponse = response.data;
      dispatch(setQueueItems(searchResponse.queueItems));
      dispatch(setQueueItemsTotal(searchResponse.totalResults || 0));
    } catch (ex) {
      console.log(ex);
    } finally {
      dispatch(setLoadingQueueItems(false));
    }
  };
};
export const setLoadingQueueItems = (value: boolean) => {
  return {
    type: KeywordActionTypes.LOADING_KEYWORD_ITEMS,
    value
  };
};
export const setKeywords = (workflowItemSteps: IWorkflowItemStep[]) => {
  return {
    type: KeywordActionTypes.SEARCH_KEYWORDS,
    value: workflowItemSteps
  };
};

export const setQueueItems = (queueItems: KeywordQueueItem[]) => {
  return {
    type: KeywordActionTypes.SEARCH_KEYWORDS_ITEMS,
    value: queueItems
  };
};

export const setQueueItemsTotal = (workflowItemStepTotal: number) => {
  return {
    type: KeywordActionTypes.SEARCH_KEYWORDS_TOTAL,
    value: workflowItemStepTotal
  };
};

export const openReport = (workflowItemStep: IWorkflowItemStep) => {
  return async (dispatch) => {
    await dispatch(view(workflowItemStep));
    return Promise.resolve(workflowItemStep);
  };
};

export const openReportById = (
  workflowItemStepId: number,
  callback?: () => void
) => {
  return async (dispatch) => {
    Api.get(
      urls.GET_WORKFLOW_ITEM_STEP_BY_ID + "?id=" + workflowItemStepId
    ).then((response: ApiResponse<IWorkflowItemStep>) => {
      if (response.ok) {
        dispatch(view(response.data));
        if (callback) {
          callback();
        }
      }
    });
  };
};
export const view = (workflowItemStep: IWorkflowItemStep) => {
  return {
    type: KeywordActionTypes.OPEN_REPORT,
    value: workflowItemStep
  };
};

export const assignAndOpen = (url, stepItemId, assignToId) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItemId,
        assignToUserId: assignToId
      }).then((result: ApiResponse<IWorkflowItemStep>) => {
        dispatch(reduceAssignAndOpen(result.data));
        if (result.data == null) {
          toast.error("Report already assigned");
        }
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceAssignAndOpen = (itemStep: IWorkflowItemStep) => {
  return {
    type: KeywordActionTypes.ASSIGN_AND_OPEN_REPORT,
    value: itemStep
  };
};

export const unAssign = (url, stepItem) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItem.id
      }).then((result: ApiResponse<KeywordQueueItem>) => {
        dispatch(reduceUnAssign(result.data));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceUnAssign = (itemStep: KeywordQueueItem) => {
  return {
    type: KeywordActionTypes.UNASSIGN,
    value: itemStep
  };
};

export const loadKeywordsIntoStore = (keywords: IKeywords) => {
  return {
    type: KeywordActionTypes.LOAD_KEYWORDS_INTO_STORE,
    value: keywords
  };
};

export const loadCountiesIntoStore = (counties: CountyInfo[]) => {
  return {
    type: KeywordActionTypes.LOAD_COUNTIES_INTO_STORE,
    value: counties
  };
};

export const loadReportTypesIntoStore = (reportTypes: ReportTypesInfo[]) => {
  return {
    type: KeywordActionTypes.LOAD_REPORT_TYPES_INTO_STORE,
    value: reportTypes
  };
};

export const AddOrUpdateKeywords = (
  url: string,
  keywords: IKeywords,
  matchedReportId?: number,
  workflowItemStepId?: number
) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        keywords,
        matchedReportId,
        workflowItemStepId
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
          dispatch(updateWorkflowItemStep(response.data));
          toast.success("Saved!");
        } else {
          toast.error("Error saving keywords!");
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const updateWorkflowItemStep = (workflowItemStep: IWorkflowItemStep) => {
  return {
    type: KeywordActionTypes.UPDATE_WORKFLOW_ITEM_STEP,
    value: workflowItemStep
  };
};

export const getCounties = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(loadCountiesIntoStore(response.data));
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const getReportTypes = (url: string) => (dispatch) =>
  new Promise(function (resolve, reject) {
    try {
      Api.get(url)
        .then((response: ApiResponse<any>) => {
          dispatch(loadReportTypesIntoStore(response.data));
          resolve(response.data);
        })
        .catch(function (ex) {
          //console.log(ex);
          reject(ex);
        });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  });

export const completeKeyword =
  (url: string, request: IPaperKeywordRequest) => (dispatch) =>
    new Promise<void>(function (resolve, reject) {
      try {
        Api.post(url, request).then((result: ApiResponse<any>) => {
          if (result.data) {
            // load next report into keywords:
            dispatch(reduceComplete(result.data));
            resolve(result.data);

            const file = b64toBlob(
              result.data.workflowItem.report.paperReport.pdf,
              "application/pdf"
            );
            const fileURL = URL.createObjectURL(file);
            dispatch(reduceImage(fileURL, false));
          } else {
            resolve();
          }
        });
      } catch (ex) {
        console.log(ex);
        reject(ex);
      }
    });

export const reduceComplete = (nextItemStep: IWorkflowItemStep) => {
  return {
    type: KeywordActionTypes.COMPLETE_DATA_ENTRY,
    value: nextItemStep
  };
};

export const searchMatches = (url: string, request: any) => (dispatch) =>
  new Promise(function (resolve, reject) {
    try {
      if (!request.dateOfCrash || !request.countyId) {
        dispatch(reduceMatches([]));
        return;
      }
      Api.post(url, request).then((result: ApiResponse<any>) => {
        if (result.data) {
          dispatch(reduceMatches(result.data));
          resolve(result.data);
        }
      });
    } catch (ex) {
      console.log(ex);
      reject(ex);
    }
  });

export const reduceMatches = (matches: IReport[]) => {
  return {
    type: KeywordActionTypes.LOAD_REPORT_MATCHES,
    value: matches
  };
};

export const loadImage =
  (documentId: string, forceNewWindow: boolean) => (dispatch) =>
    new Promise<void>(function (resolve, reject) {
      if (!documentId) {
        resolve();
        return;
      }

      documentDownloadService
        .getOnBaseImage(null, documentId)
        .then((response: any) => {
          const payload = getPdfPayload(response);
          if (!payload) {
            resolve();
            return;
          }
          const file = b64toBlob(payload, "application/pdf");
          const fileURL = URL.createObjectURL(file);
          dispatch(reduceImage(fileURL, forceNewWindow));
          resolve();
        });
    });

export const reduceImage = (fileUrl: string, forceNewWindow: boolean) => {
  return {
    type: KeywordActionTypes.LOAD_IMAGE,
    value: { fileUrl, forceNewWindow }
  };
};

export const deleteReport =
  (url: string, workflowItemStepId: number, comment: string) => (dispatch) =>
    new Promise<void>(function (resolve, reject) {
      try {
        Api.post(url, { workflowItemStepId, comment}).then(
          (result: ApiResponse<any>) => {
            if (result.data) {
              if(result.data.success)
              {
                toast.success("Report Deleted");
                dispatch(reduceStatusChange(result.data));
                console.debug("Delete:", result);
              } else {
                toast.error("Failed to Delete");
                console.debug("Delete:", result);
              }
              resolve(result.data);
            } else {
              resolve();
            }
          }
        );
      } catch (ex) {
        console.log(ex);
        reject(ex);
      }
    });

export const unDeleteReport =
  (url: string, workflowItemStepId: number) => (dispatch) =>
    new Promise<void>(function (resolve, reject) {
      try {
        Api.post(url, { workflowItemStepId }).then(
          (result: ApiResponse<any>) => {
            if (result.data) {
              dispatch(reduceStatusChange(result.data));
              resolve(result.data);
            } else {
              resolve();
            }
          }
        );
      } catch (ex) {
        console.log(ex);
        reject(ex);
      }
    });

export const reduceStatusChange = (updatedItem: IWorkflowItemStep) => {
  return {
    type: KeywordActionTypes.STATUS_CHANGE,
    value: updatedItem
  };
};

const getPdfPayload = (value: any): string => {
  if (!value) {
    return null;
  }

  if (typeof value === "string") {
    return value;
  }

  return value.pdf || value.data || value.image || null;
};

export const getImage = (reportId: number, documentId?: string) => {
  return async (dispatch) => {
    try {
      if (documentId && documentId.length > 0) {
        const response: any = await documentDownloadService.getOnBaseImage(
          null,
          documentId
        );
        const payload = getPdfPayload(response);
        dispatch(reduceDiagramImage(payload));
        return Promise.resolve(payload);
      } else {
        const data = await documentDownloadService.getPaperImageByReportId(
          reportId
        );
        dispatch(reduceDiagramImage(data));
        return Promise.resolve(data);
      }
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceDiagramImage = (image: Blob | string) => {
  return {
    type: KeywordActionTypes.GET_IMAGE,
    value: image
  };
};
